import { User } from "@/shared/interfaces";
import { ApiResourceResult } from "@/shared/vuex";
import { StoreOptions } from "vuex";
import { TransactionsClass } from "../utils/transactions.class";

export interface AdminTransactionsVuexState extends ApiResourceResult<User> {
  transactions?: User[];
  loading: boolean;
}

export const AdminTransactionsVuex: StoreOptions<AdminTransactionsVuexState> = {
  ...{ namespaced: true },
  state: {
    transactions: undefined,
    loading: false,
  },
  mutations: {},
  actions: {
    /**
     * Fetches transactions
     * @param context
     */
    fetch(context) {
      context.state.loading = true;
      TransactionsClass.fetch()
        .then((resp) => {
          context.state.count = resp.count;
          context.state.next = resp.next;
          context.state.skipped = resp.skipped;
          context.state.transactions = resp.resources;
          //   Vue.set
        })
        .finally(() => {
          context.state.loading = false;
        });
    },
  },
  modules: {},
  //
  getters: {},
};
